import type { VehicleProfile } from '@/shared/api/vehicles'

type VehicleIdentity = Pick<VehicleProfile, 'name' | 'year' | 'make' | 'model'>

function describeVehicle(vehicle: VehicleIdentity): string {
  return [vehicle.year, vehicle.make, vehicle.model].filter(Boolean).join(' ')
}

/** What people call this vehicle: its nickname, or else what it is. */
export function getVehicleTitle(vehicle: VehicleIdentity): string {
  return vehicle.name?.trim() || describeVehicle(vehicle)
}

/** What the vehicle is, when the title doesn't already say so. Onboarding names vehicles this way. */
export function getVehicleSubtitle(vehicle: VehicleIdentity): string | null {
  const description = describeVehicle(vehicle)
  return getVehicleTitle(vehicle) === description ? null : description
}
